import AcxMainTextField from "components/UI/AcxMainTextField";
import { observer } from "mobx-react";
import React from "react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import InfoIcon from "@mui/icons-material/Info";
import { Tooltip } from "@mui/material";

export const ClientCallIdFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    return (
        <AcxMainTextField
            id={props.id ?? props.filterKey}
            value={props.store[props.filterKey]}
            onChange={(e) =>
                // @ts-expect-error
                props.store.setByKey(props.filterKey, e.target.value)
            }
            endAdornment={
                <Tooltip title="This field supports comma separated values e.g.: value1,value2,value3">
                    <InfoIcon color="disabled" />
                </Tooltip>
            }
            multiline
            multilinePadding
            fullWidth
            rowsMin={1}
        />
    );
});
